
export class ListenerOptions {
public listener: string;
public name: string;
}

function ListenerOptions_tsickle_Closure_declarations() {
/** @type {?} */
ListenerOptions.prototype.listener;
/** @type {?} */
ListenerOptions.prototype.name;
}
